import {
  SAVE_CARD,
  PaymentCard,
  GET_CARDS,
  SET_CARDS,
  SET_SELECTED_CARDS,
} from './types';

export const saveCard = (card: PaymentCard) => ({
  type: SAVE_CARD,
  card,
});

export const getCards = () => ({ type: GET_CARDS });

export const setCards = (cards: PaymentCard[]) => ({ type: SET_CARDS, cards });

export const SelectCard = (cid: string, selected: boolean) => ({
  type: SET_SELECTED_CARDS,
  selected,
  cid,
});
